import { Breadcrumbs, BreadcrumbsText, Link } from 'neon-design-system';
import { config } from '../../config';

export interface Breadcrumb {
  url?: string;
  title: string;
  onClick?: () => void;
  ignoreRouter?: boolean;
}

interface Props {
  items: Breadcrumb[];
  withBorder?: boolean;
}

export const PageBreadcrumbs = ({ items, withBorder = true }: Props) => {
  items = [
    {
      title: 'Dashboard',
      ignoreRouter: true,
      url: config.loginPageUrl
    },
    ...items
  ];

  return (
    <Breadcrumbs withBorder={withBorder}>
      {items?.map((item, index) => {
        if (!item.url) return <BreadcrumbsText key={index}>{item.title}</BreadcrumbsText>;

        let linkProps = {};
        if (item.onClick) {
          linkProps = {
            onClick: (e: any) => {
              e.preventDefault();
              item.onClick && item.onClick();
            }
          };
        }

        if (item.ignoreRouter) {
          linkProps = {
            ignoreRouter: true
          };
        }

        return (
          <Link to={item.url} key={index} {...linkProps}>
            {item.title}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};
